export const GET_KYC_SUBMISSION = 'submission';
export const SUBMIT_KYC = 'submission';
export const UPLOAD_KYC = 'upload';
export const SEND_OTP = 'send-otp';